module.exports = __webpack_public_path__ + "img/c02_unitcatapultchampion_Normal_ua.847cbf02.webp";